import React from "react";
import { styled, Tooltip, tooltipClasses } from "@mui/material";
import { TooltipStyling } from "../utils/TooltipStyling";
import ValueWithFallback from "../ui/ValueWithFallback";
import { FingerprintOutlined } from "@mui/icons-material";

export default function Campaigns({ fieldName, campaign, flag, clock }) {
  const HtmlInfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: TooltipStyling,
  }));

  return (
    <>
      {campaign && (
        <HtmlInfoTooltip title={ValueWithFallback(campaign)}>
          <div className="flex-[0_0_24px]" data-testid="campaign-icon">
            <FingerprintOutlined sx={{ color: "#800080" }} />
          </div>
        </HtmlInfoTooltip>
      )}
    </>
  );
}
